import { useRouter } from 'next/router'

import { useAppDispatch } from '~/redux/hooks'
import { closeMenu } from '~/redux/slices/menu'
import BookTutorButton from '~/components/BookTutorButton'
import CurriculumSelection from '~/curriculum/components/CurriculumSelection'
import { CurriculumSelectionPoints } from '~/curriculum/constants/curriculum.const'
import { AppLanguage } from '~/types/locale'
import appConfig from '~/config/app'

import InviteFriendButton from './InviteFriendButton'
import MenuDivider from './MenuDivider'
import MenuUtilityLinks from './MenuUtilityLinks'

export default function MenuBottomBar({ isStacked = false }: { isStacked?: boolean }): React.ReactElement {
  const dispatch = useAppDispatch()
  const isNO = useRouter().locale === AppLanguage.NO

  return (
    <div
      className={
        isStacked
          ? 'flex flex-col gap-2 pb-2 pt-4'
          : 'relative flex flex-wrap items-center justify-between gap-y-2 border-t border-gray-ghost px-4 pb-4.5 pt-3.5 lg:px-8'
      }
      data-test-id="menu-bottom-bar"
    >
      <div className={isStacked ? 'flex w-full flex-col gap-2' : 'flex items-center gap-2.5'}>
        {!appConfig.isMobileApp && isNO && !appConfig.isSchoolPlatform && (
          <BookTutorButton
            className={isStacked ? 'w-full' : 'whitespace-nowrap'}
            onClickHandler={() => dispatch(closeMenu())}
            variant="menu"
          />
        )}
        {!appConfig.isSchoolPlatform && <InviteFriendButton />}
      </div>
      {isStacked && <MenuDivider />}
      <div className="xl:absolute xl:left-1/2 xl:top-1/2 xl:-translate-x-1/2 xl:-translate-y-1/2">
        <CurriculumSelection selectionPoint={CurriculumSelectionPoints.HAMBURGER_MENU} theme="dark" />
      </div>
      {isStacked && <MenuDivider />}
      <MenuUtilityLinks isStacked={isStacked} />
    </div>
  )
}
